var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 46,
    fill: "#554CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6673 37.7465C61.6673 46.3319 55.0007 47.6652 55.0007 55.6665C55.0007 59.7972 50.8367 60.1452 47.6673 60.1452C44.93 60.1452 38.886 59.1065 38.886 55.6639C38.886 47.6665 32.334 46.3332 32.334 37.7465C32.334 29.7052 39.3807 23.1865 47.1113 23.1865C54.8447 23.1865 61.6673 29.7052 61.6673 37.7465Z",
    fill: "#FFE5A9",
    transform: "translate(9, 9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5573 66.3332C52.5573 67.4372 49.5786 69.6665 47.0013 69.6665C44.424 69.6665 41.4453 67.4372 41.4453 66.3332C41.4453 65.2292 44.4226 65.6665 47.0013 65.6665C49.5786 65.6665 52.5573 65.2292 52.5573 66.3332Z",
    fill: "#CCD6DD",
    transform: "translate(9, 9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.277 36.723C52.7557 36.2017 51.913 36.2017 51.3916 36.723L47.001 41.1137L42.6103 36.723C42.089 36.2017 41.2463 36.2017 40.725 36.723C40.2037 37.2444 40.2037 38.087 40.725 38.6084L45.6677 43.551V57.6657C45.6677 58.403 46.265 58.999 47.001 58.999C47.737 58.999 48.3343 58.403 48.3343 57.6657V43.551L53.277 38.6084C53.7983 38.087 53.7983 37.2444 53.277 36.723Z",
    fill: "#464646",
    transform: "translate(9, 9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 64.333C55 65.805 53.8053 66.9997 52.3333 66.9997H41.6667C40.1947 66.9997 39 65.805 39 64.333V56.333H55V64.333Z",
    fill: "#99AAB5",
    transform: "translate(9, 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbIcon);
export default __webpack_public_path__ + "static/media/lightbulb_icon.e993838d62b8556dd83cdb9bd248da67.svg";
export { ForwardRef as ReactComponent };